import React, { type FC } from 'react';
import Pagination from '@mui/material/Pagination';
import { type PaginationDetails } from './interfaces';
import { useTranslation } from 'react-i18next';
import { useScreenSize } from 'components/Layout';
import { Button } from '../Inputs';

interface PaginatorProps {
    paginationDetails: PaginationDetails,
    onPageChange: (page: number) => void
    isInfiniteScroll?: boolean
}

const MOBILE_PAGE_SIZE = 10;

export const Paginator: FC<PaginatorProps> = (props) => {
    const { t } = useTranslation('common');
    const { paginationDetails, onPageChange, isInfiniteScroll } = props;
    const { isMobile } = useScreenSize();
    const shouldShowLoadMoreButton = isInfiniteScroll && paginationDetails.currentPage < paginationDetails.pagesCount && (paginationDetails.total || 0) > (paginationDetails.pageSize || MOBILE_PAGE_SIZE);

    const handlePageChange = (_, page) => onPageChange(page);

    return isInfiniteScroll ? shouldShowLoadMoreButton  && (
        <Button
            variant="text"
            className="pagination_load_more_button"
            onClick={() => onPageChange(paginationDetails.currentPage + 1)}
            fullWidth
        >
            {t('load_more')}
        </Button>
    ) : (
        <div className="table_pagination_container">
            <p className="pagination_text">
                {paginationDetails.currentRangeStart} - {paginationDetails.currentRangeEnd} {t('of')} {paginationDetails.total ?? '??'}
            </p>
            <Pagination
                className="pagination_component"
                count={paginationDetails.pagesCount}
                page={paginationDetails.currentPage}
                onChange={handlePageChange}
                size={ isMobile ? 'large' : 'medium' }
            />
        </div>
    )
}
